import styled from 'styled-components';

import { getSearchLandingFeedSubSectionTrackingInfo } from 'homepage/utils/getSearchLandingFeedSubsectionTrackingInfo';
import { hideScrollbars } from 'styles/utils/hideScrollbars';
import { IConstructorUserParams } from 'search/types/ConstructorUserParams';
import { IModuleTrackingData } from 'homepage/types/ModuleTrackingData';
import { ISubSection } from 'homepage/types/Feed';
import { VerticalListSection } from 'homepage/components/verticalListCarouselSection/VerticalListSection';
import {
  VERTICAL_LIST_CAROUSEL_PRICE_LIST_SECTION,
  VERTICAL_LIST_CAROUSEL_RANK_LIST_SECTION,
} from 'homepage/enums/contentConstants';
import { sendTrackingEvent } from 'tracking/utils/sendTrackingEvent';
import { useTriggerSwipeEvent } from 'homepage/hooks/useTriggerSwipeEvent';
import { useFeatureFlag } from 'shared/hooks/useFeatureFlag';
import { FeatureFlags } from 'featureFlags/constants';

interface IVerticalListCarouselSection {
  constructorUserParams?: IConstructorUserParams;
  moduleTrackingData: IModuleTrackingData;
  subsections: ISubSection[];
}

export const VerticalListCarouselSection = ({
  constructorUserParams,
  moduleTrackingData,
  subsections,
}: IVerticalListCarouselSection) => {
  const { trackScrollEvent } = useTriggerSwipeEvent(moduleTrackingData);
  const isConsumerSearchEnabled = useFeatureFlag(FeatureFlags.TEMP_WEB_ENABLE_SEARCH_MICROFRONTEND);

  const handleSubSectionClick = (index, subsection) => {
    sendTrackingEvent('CMS_MODULE_TAP', {
      service_name: isConsumerSearchEnabled ? 'consumer_search' : 'constructor',
      ...getSearchLandingFeedSubSectionTrackingInfo(moduleTrackingData, subsection, index),
    });
  };

  if (subsections?.length === 0) return null;
  for (const sub of subsections) {
    if (
      sub?.type !== VERTICAL_LIST_CAROUSEL_PRICE_LIST_SECTION &&
      sub?.type !== VERTICAL_LIST_CAROUSEL_RANK_LIST_SECTION
    ) {
      return null;
    }
  }

  return (
    <VerticalListCarouselSection.Container onScroll={trackScrollEvent}>
      {subsections?.map((section, index) => (
        <VerticalListSection
          constructorUserParams={constructorUserParams}
          onClick={() => handleSubSectionClick(index, section)}
          key={section?.uuid || section?.id}
          {...section}
          moduleTrackingData={{
            ...getSearchLandingFeedSubSectionTrackingInfo(moduleTrackingData, section, index),
          }}
        />
      ))}
    </VerticalListCarouselSection.Container>
  );
};

VerticalListCarouselSection.Container = styled.div`
  display: flex;
  padding: 32px 0 32px 8px;
  max-width: 100%;
  overflow-x: scroll;
  ${hideScrollbars};
  justify-content: center;
  width: 100%;

  > div:nth-child(1n + 3) {
    display: none;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.mediumSmall}px) {
    justify-content: flex-start;
    padding: 60px 32px;

    > div:nth-child(1n + 3) {
      display: block;
    }
  }
`;
